export const LIMIT = 10;
export const UPLOAD_CONST = "";
export const URI = process.env.REACT_APP_URI;
// export const URI = "http://localhost:5006";
